import {
  Component,
  Input,
  EventEmitter,
  OnInit,
  Output,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { FileUpload } from 'primeng/fileupload';
import { UploadService } from '../../../services/upload/upload.service';
import { DmsFile } from '../../../modal/upload/model/upload.model';
@Component({
  selector: 'app-constitute-committee',
  standalone: false,
  templateUrl: './constitute-committee.component.html',
  styleUrl: './constitute-committee.component.scss',
})
export class ConstituteCommitteeComponent implements OnInit, OnDestroy {
  userList: any;
  @Output() stepCompleted = new EventEmitter<void>();
  @Input() isDocumentSectionHide: boolean = false;
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() title: any;
  selectedUserList: any[] = [];
  selectedUser: any;
  payload: {
    proposal_id: any;
    proposal_name: any;
  };
  proposalForm: FormGroup;
  challengeForm: FormGroup;
  @Input() schemeType: any;
  @Input() getUrl: any;
  @Input() postUrl: any;
  @Input() id: any;
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Output() submitProposal: EventEmitter<any> = new EventEmitter();
  filteredUser: any;
  allDmsFiles: any[] = [];
  committeeForm: FormGroup;
  assignmentForm: FormGroup;
  committeeName: any;
  committeeID: any;
  showPanel: boolean = true;
  schemes = [];
  selectedScheme: any;
  schemeCommittees: any;
  CommitteeCols = [{ field: 'name', header: 'Name', filterType: 'text' }];
  memberCols = [
    { field: 'slNo', header: 'Sl Number', filterType: 'text' },
    { field: 'user', header: 'Designation', filterType: 'text' },
    { field: 'role', header: 'Role', filterType: 'text' },
  ];
  memberColsData = [
    { field: 'slNo', header: 'Sl Number', filterType: 'text' },
    { field: 'memberName', header: 'Name of the member', filterType: 'text' },
    { field: 'designation', header: 'Designation', filterType: 'text' },
    { field: 'role', header: 'Role', filterType: 'text' },
    { field: 'mobile', header: 'Mobile No.', filterType: 'text' },
    { field: 'email', header: 'Email ID', filterType: 'text' },
    { field: 'landline', header: 'Landline No.', filterType: 'text' },
  ];

  members: any;
  committeemember: any;
  addCommitteeDialog: boolean = false;
  updateCommitteDialog: boolean = false;
  selectedCommittee: any;
  editMemberDialog: boolean = false;
  private subscriptions = new Subscription();
  userInputMode: 'dropdown' | 'manual' = 'dropdown';
  selectedTabIndex = 0;
  showDeleteConfirmDialog: boolean = false;
  committeeToDelete: any = null;
  committeeDeleteIndex: number = -1;
  userID: any;
  uploadedUrl: any;
  apiUrl = environment.APIUrl;
  uploadedFileName: string = '';
  file: File;
  fileData: any

  @ViewChild('fileUpload') fileUpload!: FileUpload;
  constructor(
    private api: ApiService,
    private uploadService: UploadService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private messageService: MessageService
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }

  ngOnInit(): void {
    console.log('>>>>>stepDetails Constitute Committee', this.stepDetails);
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName,
      };
      //console.log(this.payload);
    });
    this.committeeForm = this.fb.group({
      committeeName: ['', Validators.required],
    });

    this.assignmentForm = this.fb.group({
      user: [null],
      user_name: [''],
      role: ['', Validators.required],
      designation: [''],
      contact_details: [''],
      mobile_no: [''],
      email_id: [''],
      landline_no: [''],
    });

    // Set initial validation
    this.updateFormValidation();
    this.getCommittee();
    this.getUserList();
    this.getfile();
  }

  toggleSection(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }
  expandedSections: { [key: string]: boolean } =
    {
      basicInfo: true,
      equipment: false,
      quantity: false,
      cost: false,
      detailedInfo: false,
      uploads: false,
      vendorTable: false
    };

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  goToNextStep() {
    this.stepCompleted.emit();
  }

  loadSchemeCommittees(event?: any) {
    // If event is passed (PrimeNG onChange event), use it to get the selected value
    if (event && event.value) {
      this.selectedScheme = event.value;
      console.log('Committee selected from onChange event:', this.selectedScheme);
    }

    // Validate selectedScheme before making API call
    if (!this.selectedScheme) {
      console.warn('No scheme selected in loadSchemeCommittees');
      return;
    }

    const committeeId = this.selectedScheme.id || this.selectedScheme.value || this.selectedScheme.committee_id;
    if (!committeeId) {
      console.warn('Selected scheme missing ID:', this.selectedScheme);
      return;
    }

    const sub = this.api
      .getAPI(`/master/committee/member/?committee=${committeeId}`)
      .subscribe((res: any) => {
        this.committeemember = res;
      });
    this.subscriptions.add(sub);
  }

  // getCommittee() {
  //   const sub = this.api.getAPI(`/transaction/committee/?proposal=${this.payload.proposal_id}`).subscribe((res: any) => {
  //     if (res.length == 0) {
  //       this.showPanel = true
  //       this.api.getAPI(`/master/committee/`).subscribe((res: any) => {
  //         this.schemes = res;
  //       });
  //     } else {
  //       this.showPanel = false
  //       this.committeeName = res[0].name;
  //       this.committeemember = res[0].members;
  //       this.committeeID = res[0].id
  //     }
  //   });
  //   this.subscriptions.add(sub);
  // }
  committees: any = [];

  getCommittee() {
    const sub = this.api
      .getAPI(`/transaction/committee/?proposal=${this.payload.proposal_id}`)
      .subscribe((res: any) => {
        this.api.getAPI(`/master/committee/`).subscribe((res: any) => {
          this.schemes = res.data; // committees available for dropdown
          console.log('>>>>>res.data', this.schemes);

        });
        if (res.length === 0) {
          this.showPanel = true;
          // this.api.getAPI(`/master/committee/`).subscribe((res: any) => {
          //   this.schemes = res;
          // });
        } else {
          this.showPanel = false;
          this.committees = res; // Set all committees here
          // Add serial numbers to members and normalize user/user_name field
          this.committees.forEach((committee: any) => {
            if (committee.members && Array.isArray(committee.members)) {
              committee.members = committee.members.map((member: any, index: number) => ({
                ...member,
                slNo: index + 1,
                // Normalize: use user_name if available, otherwise use user
                user: member.user_name || member.user || '',
                memberName: member.user_name || member.user || '',
                designation: member.designation || '',
                mobile: member.mobile_no || '',
                email: member.email_id || '',
                landline: member.landline_no || '',
              }));
            }
          });
        }
      });
    this.subscriptions.add(sub);
  }

  openAddCommittee(committee: any) {
    //console.log(committee)
    this.committeeForm.reset();
    this.assignmentForm.reset();
    this.userInputMode = 'dropdown';
    this.addCommitteeDialog = true;
    this.committeeID = committee.id;
    this.updateFormValidation();
  }

  updateFormValidation() {
    if (this.userInputMode === 'dropdown') {
      // Clear manual input and its validation
      this.assignmentForm.get('user_name')?.setValue('');
      this.assignmentForm.get('user_name')?.clearValidators();
      this.assignmentForm.get('user_name')?.updateValueAndValidity();

      // Set dropdown validation
      this.assignmentForm.get('user')?.setValidators(Validators.required);
      this.assignmentForm.get('user')?.updateValueAndValidity();
    } else {
      // Clear dropdown input and its validation
      this.assignmentForm.get('user')?.setValue(null);
      this.assignmentForm.get('user')?.clearValidators();
      this.assignmentForm.get('user')?.updateValueAndValidity();

      // Set manual input validation
      this.assignmentForm.get('user_name')?.setValidators(Validators.required);
      this.assignmentForm.get('user_name')?.updateValueAndValidity();
    }
  }

  onUserInputModeChange() {
    this.updateFormValidation();
  }
  onAssignmentSubmit() {
    if (this.assignmentForm.valid) {
      let payload: any = {
        committee_id: this.committeeID,
        role: this.assignmentForm.get('role').value,
        designation: this.assignmentForm.get('designation').value || '',
        contact_details: this.assignmentForm.get('contact_details').value || '',
        mobile_no: this.assignmentForm.get('mobile_no').value || '',
        email_id: this.assignmentForm.get('email_id').value || '',
        landline_no: this.assignmentForm.get('landline_no').value || '',
      };

      // Check if using dropdown or manual entry
      if (this.userInputMode === 'dropdown' && this.assignmentForm.get('user').value) {
        payload.user_id = this.assignmentForm.get('user').value.id;
      } else if (this.userInputMode === 'manual' && this.assignmentForm.get('user_name').value) {
        payload.user_name = this.assignmentForm.get('user_name').value.trim();
      }
      const sub = this.api
        .postAPI('/transaction/committee/member/', payload)
        .subscribe({
          next: (res: any) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Committee added successfully',
            });
            this.addCommitteeDialog = false;
            // this.getCommitteeMembers();
            this.getCommittee();
            this.assignmentForm.reset();
            this.userInputMode = 'dropdown';
          },
          error: (err) => {
            console.error('Error while saving mapping:', err);

            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to save mapping. Please try again.',
            });
          },
        });
      this.subscriptions.add(sub);
    }
  }
  memberID: any;
  updateCommittemeber(member: any, committee: any) {
    console.log(member, committee)
    const matchedUser = this.userList.find((u) => u.loginname === member.user);

    // Check if member has user_id (from dropdown) or user_name (manual entry)
    const commonPatch = {
      role: member.role,
      designation: member.designation || '',
      contact_details: member.contact_details || '',
      mobile_no: member.mobile_no || member.mobile || '',
      email_id: member.email_id || member.email || '',
      landline_no: member.landline_no || member.landline || '',
    };

    if (matchedUser) {
      this.userInputMode = 'dropdown';
      this.assignmentForm.patchValue({
        user: matchedUser,
        user_name: '',
        ...commonPatch,
      });
    } else if (member.user_name) {
      this.userInputMode = 'manual';
      this.assignmentForm.patchValue({
        user: null,
        user_name: member.user_name,
        ...commonPatch,
      });
    } else {
      // Fallback: try to match by user field
      this.userInputMode = 'manual';
      this.assignmentForm.patchValue({
        user: null,
        user_name: member.user || '',
        ...commonPatch,
      });
    }

    this.committeeID = committee.id;
    this.memberID = member.id;
    this.editMemberDialog = true;
    this.updateFormValidation();
  }
  onAssignmentUpdateSubmit() {
    if (this.assignmentForm.valid) {
      let payload: any = {
        committee_id: this.committeeID,
        role: this.assignmentForm.get('role').value,
        designation: this.assignmentForm.get('designation').value || '',
        contact_details: this.assignmentForm.get('contact_details').value || '',
        mobile_no: this.assignmentForm.get('mobile_no').value || '',
        email_id: this.assignmentForm.get('email_id').value || '',
        landline_no: this.assignmentForm.get('landline_no').value || '',
      };

      // Check if using dropdown or manual entry
      if (this.userInputMode === 'dropdown' && this.assignmentForm.get('user').value) {
        payload.user_id = this.assignmentForm.get('user').value.id;
      } else if (this.userInputMode === 'manual' && this.assignmentForm.get('user_name').value) {
        payload.user_name = this.assignmentForm.get('user_name').value.trim();
      }
      const sub = this.api
        .putAPI(`/transaction/committee/member/${this.memberID}/`, payload)
        .subscribe({
          next: (res: any) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Committee member updated successfully',
            });
            this.getCommittee();
            this.assignmentForm.reset();
            this.userInputMode = 'dropdown';
            this.editMemberDialog = false;
          },
          error: (err) => {
            console.error('Error while saving mapping:', err);

            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to save mapping. Please try again.',
            });
          },
        });
      this.subscriptions.add(sub);
    }
  }
  deleteMember: boolean = false;
  showDeletePopup(committee: any) {
    this.deleteMember = true;
    this.committeeID = committee.id;
  }

  ConfirmMemberDelete() {
    const sub = this.api
      .deleteAPI(`/transaction/committee/member/${this.committeeID}/`)
      .subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Member Deleted Successfully',
          });
          // window.location.reload();
          this.deleteMember = false;
          this.getCommittee();
        },
        error: (err) => {
          console.error('API Error:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to delete the Unit. Please try again.',
          });
        },
      });
    this.subscriptions.add(sub);
  }
  onCommitteeSubmit() {
    if (this.committeeForm.valid) {
      let payload = {
        proposal: this.payload.proposal_id,
        name: this.committeeForm.get('committeeName').value,
      };
      const sub = this.api
        .postAPI('/transaction/committee/', payload)
        .subscribe({
          next: (res: any) => {
            console.log('>>>>>res Committee', res);
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Committee added successfully',
            });
            this.getCommittee();
            this.committeeForm.reset();
          },
          error: (err) => {
            console.error('Error while saving mapping:', err);

            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to save mapping. Please try again.',
            });
          },
        });
    }
  }

  updateCommitte(data: any) {
    this.updateCommitteDialog = true;
    this.selectedCommittee = data;
    setTimeout(() => {
      this.committeeForm.patchValue({
        committeeName: this.selectedCommittee.name,
      });
    }, 0);
  }
  updateSubmit() {
    if (this.committeeForm.valid) {
      let payload = {
        proposal: this.payload.proposal_id,
        name: this.committeeForm.get('committeeName').value,
      };
      const sub = this.api
        .putAPI(`/transaction/committee/${this.selectedCommittee.id}/`, payload)
        .subscribe({
          next: (res: any) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Committee added successfully',
            });
            this.updateCommitteDialog = false;
            this.getCommittee();
            this.committeeForm.reset();
          },
          error: (err) => {
            console.error('Error while saving mapping:', err);

            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to save mapping. Please try again.',
            });
          },
        });
      this.subscriptions.add(sub);
    }
  }
  getCommitteeMembers() {
    const sub = this.api
      .getAPI(`/transaction/committee/member/`)
      .subscribe((res: any) => {
        //console.log(res)
        this.members = res;
        console.log('>>>>>this.member', this.members);
        const dmsFiles: DmsFile[] = this.members.dms_files;
        this.allDmsFiles = dmsFiles;
      });
    this.subscriptions.add(sub);
  }
  getUserList() {
    const sub = this.api.getAPI('/account/users/').subscribe((res: any) => {
      this.userList = res.results?.data || res.data;
    });
    this.subscriptions.add(sub);
  }
  addFromExisting() {
    // Debug: Log the current selectedScheme value
    console.log('Selected Scheme:', this.selectedScheme);
    console.log('Schemes array:', this.schemes);

    // Validate that a scheme is selected
    if (!this.selectedScheme) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please select a committee from the dropdown first.',
      });
      return;
    }

    // Check if selectedScheme has an id property (might be different structure)
    const committeeId = this.selectedScheme.id || this.selectedScheme.value || this.selectedScheme.committee_id;
    if (!committeeId) {
      console.error('Selected scheme structure:', this.selectedScheme);
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Selected committee is missing required information. Please try selecting again.',
      });
      return;
    }

    // Validate that proposal_id is available
    if (!this.payload || !this.payload.proposal_id) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Proposal information is not available. Please refresh the page.',
      });
      console.error('Payload or proposal_id is missing:', this.payload);
      return;
    }

    // Get committee name - handle different possible structures
    const committeeName = this.selectedScheme.name || this.selectedScheme.label || this.selectedScheme.committee_name;

    let payload = {
      proposal: this.payload.proposal_id,
      name: committeeName,
      committe_master: committeeId,
    };

    console.log('Adding committee with payload:', payload);

    const sub = this.api.postAPI('/transaction/committee/', payload).subscribe({
      next: (res: any) => {
        console.log('Committee added successfully:', res);
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Committee added successfully',
        });
        this.addCommitteeDialog = false;
        this.selectedScheme = null;
        this.getCommittee();
        this.getCommitteeMembers();
        this.assignmentForm.reset();
      },
      error: (err) => {
        console.error('Error while adding committee:', err);
        const errorMessage = err?.error?.detail || err?.error?.message || 'Failed to add committee. Please try again.';
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: errorMessage,
        });
      },
    });
    this.subscriptions.add(sub);
  }
  openDeleteDialog(committee: any, index: number) {
    this.committeeToDelete = committee;
    this.committeeDeleteIndex = index;
    this.showDeleteConfirmDialog = true;
  }
  confirmDeleteCommittee() {
    const id = this.committeeToDelete.id;
    const sub = this.api.deleteAPI(`/transaction/committee/${id}/`).subscribe({
      next: () => {
        this.committees.splice(this.committeeDeleteIndex, 1);
        this.messageService.add({
          severity: 'success',
          summary: 'Deleted',
          detail: 'Committee removed successfully.',
        });
        this.getCommittee();
        this.showDeleteConfirmDialog = false;
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to delete committee.',
        });
        this.showDeleteConfirmDialog = false;
      },
    });
    this.subscriptions.add(sub);
  }
  onUpload(event: any): void {
    const file = event.files?.[0];
    this.uploadedFileName = file.name;
    this.file = file;
  }
  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 35 ? fileName.substring(0, 30) + '...' : fileName;
  }
  clearUpload(fileUpload: any) {
    this.uploadedFileName = null;
    // this.uploadedUrl = null;
    fileUpload.clear();
  }
  onSubmit() {
    const formData = new FormData();
    formData.append('proposal_step', this.id);

    if (this.file) {
      formData.append('file', this.file);
    }

    if (this.fileData && this.fileData.id) {
      // Update existing file
      const sub = this.api.putAPI(`/idex/hpsc/committe/${this.fileData.id}/`, formData).subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Data Uploaded Successfully',
          });
          this.uploadedFileName = null
          this.getfile()
        },
        error: (err) => {
          console.error('Error updating file:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to update file',
          });
        },
      });
      this.subscriptions.add(sub);
    } else {
      // Create new file
      const sub = this.api.postAPI(`/idex/hpsc/committe/`, formData).subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Data Uploaded Successfully',
          });
          this.uploadedFileName = null
          this.getfile()
        },
        error: (err) => {
          console.error('Error uploading file:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to upload file',
          });
        },
      });
      this.subscriptions.add(sub);
    }
  }
  getfile() {
    const sub = this.api.getAPI(`/idex/hpsc/committe/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`).subscribe({
      next: (res: any) => {
        this.fileData = res.data
        this.uploadedUrl = res.data.file
      },
      error: (err) => {
      },
    });

    this.subscriptions.add(sub);
  }

  // Vendor Management Event Handlers
  onVendorAdded(event: any): void {
    console.log('Vendor added:', event);
  }

  onVendorUpdated(event: any): void {
    console.log('Vendor updated:', event);
  }

  onVendorDeleted(event: any): void {
    console.log('Vendor deleted:', event);
  }

  onFilesSubmitted(event: any): void {
    console.log('Files submitted:', event);
  }
  get committeeColumns() {
    return this.schemeType === 'rev' ? this.memberCols : this.memberColsData;
  }

}
